import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { authApi } from '@/features/auth/authApi';
import { balanceFinanceApi } from '@/features/balanceFinance/balanceFinanceApi';
import { debtDynamicsApi } from '@/features/debtDynamics/debtDynamicsApi';
import { departmentsApi } from '@/features/departments/departmentsApi';
import { employeePositionApi } from '@/features/employeePositions/employeePositionsApi';
import { employeesApi } from '@/features/employees/employeesApi';
import { locationsApi } from '@/features/locations/locationsApi';
import { myBranchApi } from '@/features/myBranch';
import { organizationApi } from '@/features/organization/organizationApi';
import { organizationsApi } from '@/features/organizations/organizationsApi';
import { paymenByCategoriesApi } from '@/features/paymenByCategories/paymenByCategoriesApi';
import { paymentApi } from '@/features/payment/paymentApi';
import { paymentsStatusByTypeOfAccrualsApi } from '@/features/paymentsStatusByTypeOfAccruals/paymentsStatusByTypeOfAccrualsApi';
import { permissionsApi } from '@/features/permissions/permissionsApi';
import { personalAccountsApi } from '@/features/personalAccounts';
import { reportsApi } from '@/features/reports/reportsApi';
import { rolesApi } from '@/features/roles/rolesApi';
import { subdivisionsApi } from '@/features/subdivisions/subdivisionsApi';
import uiSlice from '@/features/ui/uiSlice';
import { undistributedPaymentsApi } from '@/features/undistributedPayments/undistributedPaymentsApi';

const rootReducer = combineReducers({
  [uiSlice.name]: uiSlice.reducer,
  [authApi.reducerPath]: authApi.reducer,
  [balanceFinanceApi.reducerPath]: balanceFinanceApi.reducer,
  [departmentsApi.reducerPath]: departmentsApi.reducer,
  [employeePositionApi.reducerPath]: employeePositionApi.reducer,
  [employeesApi.reducerPath]: employeesApi.reducer,
  [locationsApi.reducerPath]: locationsApi.reducer,
  [myBranchApi.reducerPath]: myBranchApi.reducer,
  [organizationApi.reducerPath]: organizationApi.reducer,
  [organizationsApi.reducerPath]: organizationsApi.reducer,
  [paymentApi.reducerPath]: paymentApi.reducer,
  [debtDynamicsApi.reducerPath]: debtDynamicsApi.reducer,
  [paymenByCategoriesApi.reducerPath]: paymenByCategoriesApi.reducer,
  [paymentsStatusByTypeOfAccrualsApi.reducerPath]:
    paymentsStatusByTypeOfAccrualsApi.reducer,
  [permissionsApi.reducerPath]: permissionsApi.reducer,
  [personalAccountsApi.reducerPath]: personalAccountsApi.reducer,
  [reportsApi.reducerPath]: reportsApi.reducer,
  [rolesApi.reducerPath]: rolesApi.reducer,
  [subdivisionsApi.reducerPath]: subdivisionsApi.reducer,
  [undistributedPaymentsApi.reducerPath]: undistributedPaymentsApi.reducer,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    // The shared organization page keeps its logo as a Blob and uploads a File (GSB-8317), as in BMS and Supply.
    getDefaultMiddleware({ serializableCheck: false }).concat([
      authApi.middleware,
      balanceFinanceApi.middleware,
      departmentsApi.middleware,
      employeePositionApi.middleware,
      employeesApi.middleware,
      locationsApi.middleware,
      myBranchApi.middleware,
      paymentApi.middleware,
      organizationApi.middleware,
      organizationsApi.middleware,
      debtDynamicsApi.middleware,
      paymenByCategoriesApi.middleware,
      paymentsStatusByTypeOfAccrualsApi.middleware,
      permissionsApi.middleware,
      personalAccountsApi.middleware,
      reportsApi.middleware,
      rolesApi.middleware,
      subdivisionsApi.middleware,
      undistributedPaymentsApi.middleware,
    ]),
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
